import * as React from 'react'
import { useContractForm } from '../../context/ContractFormContext'
import ContractWages from '../../forms/contract/stages/ContractWages'
import ContractParameters from '../../forms/contract/stages/ContractParameters'
import ContractTaxes from '../../forms/contract/stages/ContractTaxes'
import ContractLumpsCosts from '../../forms/contract/stages/ContractLumpsCosts'
import ContractEu from '../../forms/contract/stages/ContractEu'
import ContractAdditionalRates from '../../forms/contract/stages/ContractAdditionalRates'
import ContractVacations from '../../forms/contract/stages/ContractVacations'

const ContractContent = ({ companyId }) => {
  const { formTab } = useContractForm()
  const TABS = [
    {
      type: 'contract-parameters',
      content: <ContractParameters companyId={companyId} />,
    },
    {
      type: 'wages',
      content: <ContractWages />,
    },
    {
      type: 'taxes-and-deductions',
      content: <ContractTaxes />,
    },
    {
      type: 'lumpscosts',
      content: <ContractLumpsCosts />,
    },
    {
      type: 'eu-qualifications',
      content: <ContractEu />,
    },
    {
      type: 'additional-rates',
      content: <ContractAdditionalRates />,
    },
    {
      type: 'vacations',
      content: <ContractVacations />,
    },
  ]
  const activeTab = TABS.find((tab) => tab.type === formTab)

  const contentRef = React.useRef<HTMLDivElement>(null)
  React.useLayoutEffect(() => {
    contentRef.current?.scrollTo({ top: 0, left: 0 })
  }, [formTab])

  return (
    <div ref={contentRef} className="tw-flex-1 tw-overflow-auto tw-p-4 tw-pr-8">
      {activeTab?.content}
    </div>
  )
}

export default ContractContent
